import React from 'react'
import profile from '../images/damini-sharma.webp';
import profile1 from '../images/preet-kaur.webp';
import profile2 from '../images/shilpi-verma.webp';
import profile3 from '../images/isha-tripathi.webp';
import profile4 from '../images/megha-sahu.webp';
import profile5 from '../images/pooja-saini.webp';
import profile6 from '../images/shauryaa-singh.webp';
import profile7 from '../images/shagun-kaur.webp';
import profile8 from '../images/pranshi-pandey.webp';
import profile9 from '../images/gayatri-mishra.webp';
import profile10 from '../images/monika-yadav.webp';
import profile11 from '../images/maria-khan.webp';
import profile12 from '../images/sapna-singh.webp';
import profile13 from '../images/mahima-chaudhry.webp';
import profile14 from '../images/annu-chauhan.webp';
import profile15 from '../images/anjali-arora.webp';
import profile16 from '../images/surbhi-shukla.webp';
import profile17 from '../images/arushi-patel.webp';
import profile18 from '../images/aditi-kumari.webp';
import profile19 from '../images/laxmi-pathak.webp';
import { Link } from "react-router-dom";

export default function Profile() {
  const num = "0000000000";
  const phone = "0000000000";
  const message = encodeURIComponent("Hi Looking For Service [https://www.riyadubey.com/] RD");
  return (
    <>
    <section className="ptb-40 bg-2" id="profile">
    <div className="container">
        <h2>Have Fun with Real & Verified Escorts</h2>
        <div className="rd-profile-main flex-row justify-between">
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile} width="200" height="300" alt="Damini Sharma Gurgaon Escorts" title="Damini Sharma Gurgaon Escorts" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Damini Sharma</span>
                 <p>Damini Sharma has a chilled-out feel and easy confidence that make everything feel relaxed and warm. They all say that she is extremely friendly and accessible Gurgaon escort.</p>
                 <p>“I love to spend time on slow, intimate things, where you can be close to one another, touch them, and feel each other, and share a warm moment and have a quiet conversation that creates the deep, unspoken chemistry.”</p>
                 <p className="rd-age">⏳21, Years | 💸₹15,000  Hour | <Link to="/huda-city-center-escorts">📍 Huda City Center</Link></p>          
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile1} width="200" height="300" alt="Preet Kaur Escorts in Gurgaon" title="Preet Kaur Escorts in Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Preet Kaur</span>
                 <p>Preet Kaur is a very welcoming escort in Gurgaon, and she is inviting personality with a naturally full and curvy figure, which contributes to her comfortable presence. She is easy, loving, and always relaxed in every meeting.</p>
                 <p>“I like intimacy that is slow and real – caresses, mutual warmth, and being able to feel when being comfortable becomes silent desire.”</p>
                 <p className="rd-age">⏳22, Years | 💸₹10,000  Hour | <Link to="/dlf-cyber-city-escorts">📍Dlf Cyber City</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile2} width="200" height="300" alt="Shilpi Verma Gurgaon escort service" title="Shilpi Verma Gurgaon escort service" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Shilpi Verma</span>
                 <p>Shilpi Verma is thoughtful, artistic, and self-assured Gurgaon escort; people gravitate toward her for her honesty and insightful views. She prefers in-depth conversations over small talk.</p>
                 <p>“I enjoy sharing time together in quiet conversation and easy small talk when everything feels effortless, warm, and genuine.”</p>
                 <p className="rd-age">⏳20, Years | 💸₹8,000  Hour | <Link to="/mg-road-escorts">📍MG Road</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile3} width="200" height="300" alt="Isha Tripathi Escort service Gurgaon" title="Isha Tripathi Escort service Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Isha Tripathi</span>
                 <p>Isha Tripathi is very sensual, expressive, and, of course, sensitive to physical intimacy. Her presence is strong yet reassuring, and it creates an attraction by default.</p>
                 <p>“I am a Gurgaon escort who is sure that touch speaks more than words, I mean slow and deliberate propinquity that accentuates all sensations, creates suspense, and makes one entirely engaged in the action.”</p>
                 <p className="rd-age">⏳23, Years | 💸₹9,000  Hour | <Link to="/south-city-escorts">📍South City</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile4} width="200" height="300" alt="Megha Sahu Call girls in Gurgaon" title="Megha Sahu Call girls in Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Megha Chauhan</span>
                 <p>Megha Chauhan is an irresistibly seductive petite Gurgaon escorts girl, captivating people effortlessly. Her charismatic self-assurance guarantees every encounter will be engaging and authentic.</p>
                 <p>“I love the feeling of intimacy that comes from ease, touching, jesting, and intimacy, where the connection feels effortless yet completely engaged.”</p>
                 <p className="rd-age">⏳24, Years | 💸₹12,000  Hour | <Link to="/golf-course-escorts">📍Golf Course</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile5} width="200" height="300" alt="Gurgaon call girls Pooja Saini" title="Gurgaon call girls Pooja Saini" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Pooja Saini</span>
                 <p>Pooja Saini is so comfortable and natural, it immediately makes you feel at home. She is cheerful, amusing, and can turn even ordinary situations into occasions.</p>
                 <p>“I like being together, making fun together, touching each other, and forgetting the world, those few seconds that are so easy but seem to last forever.”</p>
                 <p className="rd-age">⏳23, Years | 💸₹13,000  Hour | <Link to="/iffco-chowk-escorts">📍Iffco Chowk</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile6} width="200" height="300" alt="Shauryaa Singh Best escorts in Gurgaon" title="Shauryaa Singh Best escorts in Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Shauryaa Singh</span>
                 <p>Shanaya Singh is a beautiful girlfriend whose entry glamours any room. She loves the cozy intimacy. She is strong-willed, flirtatious, and never clumsy; she is so good at making warm and heavy moments.</p>
                 <p>“I am an outgoing person, I like to see new places, and have high-quality hangouts and makeouts. It can be coffee-shopping at local cafes or hardcore partying in the evening. I like to make up fun and relaxed times that we will both love to enjoy.”</p>
                 <p className="rd-age">⏳26, Years | 💸₹18,000  Hour | <Link to="/manesar-escorts">📍Manesar</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile7} width="200" height="300" alt="Shagun Kaur Gurgaon escort agency" title="Shagun Kaur Gurgaon escort agency" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Shagun Kaur</span>
                 <p>Shagun Kaur is a very welcoming and friendly friend who prioritizes establishing a pleasant, comfortable relationship first. Every moment is casual and welcoming through her easy smile and easygoing character.</p>
                 <p>“I adore the pleasure of the body, finding out what is good, and enjoying moments of nakedness. Caresses, mutual warmth, teasing intimacy are what leave the time with me memorable.”</p>
                 <p className="rd-age">⏳27, Years | 💸₹12,000  Hour | <Link to="/sohna-road-escorts">📍Sohna Road</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile8} width="200" height="300" alt="Pranshi Pandey Verified escorts in Gurgaon" title="Pranshi Pandey Verified escorts in Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Pranshi Pandey</span>
                 <p>Priyanshi Pandey is a young and charming person. You will see her as a compassionate person you met. She is a fashion-oriented flair, who is always willing to have fun and memorable moments.</p>
                 <p>“I like finding new places to hang out, going to exciting locations, and finding adventurous and fun men. All our hangouts with me are full of laughter and excitement, whereas makeouts will be intense.”</p>
                 <p className="rd-age">⏳22, Years | 💸₹18,000  Hour | <Link to="/bijwasan-escorts">📍Bijwasan</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile9} width="200" height="300" alt="Gayatri Mishra Luxury escort service Gurgaon" title="Gayatri Mishra Luxury escort service Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Gayatri Mishra</span>
                 <p>Gayatri Mishra is an impressive young lady, always going after what she wants without hesitation or fear. Her formidable and daring presence makes every encounter with her memorable. Her attire makes every encounter with her captivating.</p>
                 <p>“I like games, pranking, and experiencing lust without shyness. When I am close to you, you will have sparks, laughter, and a bold dose of fun that will make everything interesting.”</p>
                 <p className="rd-age">⏳23, Years | 💸₹12,000  Hour | <Link to="/bristol-chowk-escorts">📍Bristol Chowk</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile10} width="200" height="300" alt="Monika Yadav Affordable escorts in Gurgaon" title="Monika Yadav Affordable escorts in Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Monika Yadav</span>
                 <p>Monika Yadav is an accomplished and engaging escort who prides herself on making every experience unforgettable. Her nature of being the lovable person in the room makes her highly demanding.</p>
                 <p>“I am a person who likes deep, intimate memories and close moments where we can just have fun together, exploring each other, smiling, and having fun together.”</p>
                 <p className="rd-age">⏳22, Years | 💸₹14,000  Hour | <Link to="/ardee-city-escorts">📍Ardee City</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile11} width="200" height="300" alt="Maria Khan Hire escorts in Gurgaon" title="Maria Khan Hire escorts in Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Maria Khan</span>
                 <p>Maria Khan is a tender, delicate, and alluring friend whose meek character immediately catches your attention. Her light complexion and sexy figure contribute to her beauty, and every moment together with her is pleasant and welcoming.</p>
                 <p>“I like the quiet, cozy, gentle time we can spend together – caress, low-key laughter, and intimacy that can be so true and memorable.”</p>
                 <p className="rd-age">⏳27, Years | 💸₹9,000  Hour | <Link to="/vatika-city-escorts">📍Vatika City</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile12} width="200" height="300" alt="Sapna Singh Private escorts in Gurgaon" title="Sapna Singh Private escorts in Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Sapna Singh</span>
                 <p>Sapna Singh is full of life, playful, and eccentric. She enjoys having fun while adding life and light to any experience they undertake.</p>
                 <p>“I enjoy spending quality time and engaging in intense encounters, with gentle touches, mutual glances, and just a hint of wild. I can vibe out with you to the peak moments and bring out the pleasure you need.”</p>
                 <p className="rd-age">⏳28, Years | 💸₹16,000  Hour | <Link to="/surajkund-escorts">📍Surajkund</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile13} width="200" height="300" alt="Mahima Chaudhry Gurgaon me escorts" title="Mahima Chaudhry Gurgaon me escorts" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Mahima Chaudhry</span>
                 <p>Mahima Chaudhry is a thick chick and a highly attractive companion who reflects charm and self-confidence. Her presence is both relaxing and thrilling, with each time being very special and easy.</p>
                 <p>“I like to have slow, intimate moments with each other in which we can engage with each other and have soft touches, laugh quietly, and experience a closeness that makes time pass away and leaves behind great memories.”</p>
                 <p className="rd-age">⏳23, Years | 💸₹12,000  Hour | <Link to="/galleria-market-escorts">📍Galleria Market</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile14} width="200" height="300" alt="Annu Chauhan Gurgaon call girl service" title="Annu Chauhan Gurgaon call girl service" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Annu Chauhan</span>
                 <p>Anu Chauhan is an interesting friend who knows how to bring all the fantasies to life. She is a good listener, a jokester, and a source of joy and happiness in every situation, and makes being around her something to remember.</p>
                 <p>“I love to discover wants, intimate, close moments, and wholehearted focus on what is good to you. Every touch or smile I have with you is supposed to be exciting and linking.”</p>
                 <p className="rd-age">⏳25, Years | 💸₹16,000  Hour | <Link to="/palam-vihar-escorts">📍Palam Vihar</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile15} width="200" height="300" alt="Anjali Arora Safe escort service Gurgaon" title="Anjali Arora Safe escort service Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Anjali Arora</span>
                 <p>Anjali Arora is an exquisite companion, easily charming, and model who knows how to make every time she spends together memorable, fascinating, and exceptional.</p>
                 <p>“My goal is to make our time together exciting and fulfilling – gently tease you while tenderly caressing you, fill every moment with passion and pleasure – this is my goal for our time together!”</p>
                 <p className="rd-age">⏳26, Years | 💸₹12,000  Hour | <Link to="/badshahpur-escorts">📍Badshahpur</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile16} width="200" height="300" alt="Surbhi Shukla Discreet escorts in Gurgaon" title="Surbhi Shukla Discreet escorts in Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Surbhi Shukla</span>
                 <p>Surbhi Shukla is a playful and teddy-like partner and likes to make every moment a soft, sensual touch. Either you both are out to have some chill out, or in the closed room, you will always find her in a mood, and that feels attractive every time.</p>
                 <p>“I enjoy going to parties, watching late-night films, or going out in the town and taking long rides, which become fun and sexy. It will be fun, laughing, and an unforgettable pleasure to be with me.”</p>
                 <p className="rd-age">⏳23, Years | 💸₹14,000  Hour | <Link to="/chakkarpur-escorts">📍Chakkarpur</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile17} width="200" height="300" alt="Arushi Patel Premium escort service Gurgaon" title="Arushi Patel Premium escort service Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Arushi Patel</span>
                 <p>A shy and gorgeous girl, Arushi Patel, speaks volumes with her charm. People are thrilled with her cool image and beauty, and every moment turns out to be special and sexy.</p>
                 <p>“I enjoy learning about your inner desires and making every experience thrilling and enjoyable. It’s all with me is fun, playing, and leaving you thoroughly content in the most natural way.”</p>
                 <p className="rd-age">⏳22, Years | 💸₹15,000  Hour | <Link to="/guru-dronacharya-escorts">📍Guru Dronacharya</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile18} width="200" height="300" alt="Aditi Kumari Elite escort Gurgaon" title="Aditi Kumari Elite escort Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Aditi Kumari</span>
                 <p>Aditi Kumari is a small girl with an attractive face and seductive figure. The allure and experience she possesses make each hour thrilling, fun, and memorable.</p>
                 <p>“I like to be a bit pushy, flirtatious, and assertive as I seek every passion. It’s fun, intimacy, and passion with me and ensures that each time you spend time with me, you feel the desire to spend even more time together.”</p>
                 <p className="rd-age">⏳21, Years | 💸₹18,000  Hour | <Link to="/hans-enclave-escorts">📍Hans Enclave</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
            <div className="rd-profile-box flex-row justify-between">
                <div className="rd-profile-img">
                 <img src={profile19} width="200" height="300" alt="Laxmi Pathak Top escort agency Gurgaon" title="Laxmi Pathak Top escort agency Gurgaon" />
                 <p>✔</p>
                </div>
                <div className="rd-profile-cnt">
                 <span>Laxmi Pathak</span>
                 <p>Lakshmi Pathak is highly esteemed among her peers for both her natural beauty and ability to forge meaningful relationships. She provides warmth, intimacy, and closeness – qualities which ensure every encounter becomes unforgettable.</p>
                 <p>“My aim is to connect, engage your senses, and spend quality time doing something enjoyable together. Pleasure with me may not necessarily be physical but instead emotional, fun, and unforgettable!”</p>
                 <p className="rd-age">⏳24, Years | 💸₹20,000  Hour | <Link to="/kendriya-vihar-escorts">📍Kendriya Vihar</Link></p>
                 <a href={`tel:${num}`}>Call Now</a>
                 <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
                </div>
            </div>
        </div>
    </div>
    </section>
    </>
  )
}
